export default __webpack_public_path__ + "static/media/logo.4aa3200e.svg";